import {
  CHANGE_AUTH,
  CHANGE_INVITED,
  CHANGE_FIRST_TIME,
  CHANGE_USER,
  CHANGE_USER_FIELD,
  RELOAD_USER,
  RANDOM_IMAGE,
  CHANGE_FORM_TYPE,
  CHANGE_QRCODE
} from './actions'

export default function (state = {
  authenticated: false,
  invited: false,
  firstTime: false,
  user: {},
  formType: 'login',
  qrcode: null
}, action) {
  switch (action.type) {
    case CHANGE_AUTH:
      return { ...state, authenticated: action.payload }
    case CHANGE_INVITED:
      return { ...state, invited: action.payload }
    case CHANGE_FIRST_TIME:
      return { ...state, firstTime: action.payload }
    case CHANGE_USER:
      return { ...state, user: action.payload }
    case CHANGE_USER:
      return { ...state, user: action.payload }
    case CHANGE_USER_FIELD:
      const { key, value } = action.payload

      localStorage.setItem(key, typeof (value) === 'object' ? JSON.stringify(value) : value)
      return { ...state, user: { ...state.user, [key]: value } }
    case RELOAD_USER:
      return { ...state, user: action.payload }
    case RANDOM_IMAGE:
      const image = state.user.image
      const newImage = image.substring(0, image.lastIndexOf('/') + 1) + Math.random()

      return { ...state, user: { ...state.user, image: newImage } }
    case CHANGE_FORM_TYPE:
      return { ...state, formType: action.payload }
    case CHANGE_QRCODE:
      return { ...state, qrcode: action.payload }
    default:
      return state
  }
}
